import { HistoryGetBalancesEndpoint, HistoryGetHistoryBalances } from '../constants';
export function GetBalanceHistory(api) {
    return (accountId) => {
        return api.authenticated().get(HistoryGetHistoryBalances, {
            accountId,
        }, {
            headers: { Accept: 'application/json' },
        });
    };
}
export function HistoryGetBalances(api) {
    return (payload) => {
        return api.authenticated().get(HistoryGetBalancesEndpoint, payload, {
            headers: { Accept: 'application/json' },
        });
    };
}
//# sourceMappingURL=historyGetBalance.js.map